function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import _isFunction from 'lodash/isFunction';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from '.';
import 'scss/feedback_menu.scss';

var DownloadModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DownloadModal, _React$Component);

  function DownloadModal(props) {
    var _this;

    _classCallCheck(this, DownloadModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DownloadModal).call(this, props));
    _this.state = {};
    _this._onSubmit = _this._onSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._onFeedbackSubmitFailure = _this._onFeedbackSubmitFailure.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(DownloadModal, [{
    key: "_onSubmit",
    value: function _onSubmit(e) {
      e.preventDefault();
      if (this.props.menuSubmitting) return;
      this.setState({
        feedbackSubmitFailure: false
      });
      var featureMap = {};
      this.props.features.forEach(function (feature) {
        featureMap[feature.id] = {};
        feature.values.forEach(function (featureValue) {
          featureMap[feature.id][featureValue.id] = e.target.elements["feature-value-checkbox-".concat(featureValue.id)].checked;
        });
      });
      var postFormData = {
        features: featureMap,
        contact_checkbox: e.target.elements['feedback-contact-checkbox'].checked,
        additional_feedback: e.target.elements['feedback-textarea'].value
      };
      var feedbackPromise = this.props.submitFeedback(postFormData, this.props.plotCountryCode, this.props.plotId);

      if (_isFunction(this.props.navigateToDownloadUrl)) {
        this.props.navigateToDownloadUrl(this.props.plotCountryCode, feedbackPromise);
      }

      feedbackPromise.then(this.props.modalClose).catch(this._onFeedbackSubmitFailure);
    }
  }, {
    key: "_onFeedbackSubmitFailure",
    value: function _onFeedbackSubmitFailure() {
      this.setState({
        feedbackSubmitFailure: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Modal, _extends({}, this.props, {
        closeable: true,
        classNames: "FeedbackOrDownloadModal"
      }), this.props.content && this.props.content.body);
    }
  }]);

  return DownloadModal;
}(React.Component);

DownloadModal.propTypes = {
  plotId: PropTypes.string,
  plotCountryCode: PropTypes.string,
  featuresTitle: PropTypes.string,
  features: PropTypes.array,
  menuLoading: PropTypes.bool,
  menuSubmitting: PropTypes.bool,
  menuLoadError: PropTypes.bool,
  isMobileWidth: PropTypes.bool,
  menuLoadErrorMessage: PropTypes.string,
  contactCheckboxText: PropTypes.string,
  submitButtonText: PropTypes.string,
  downloadDescription: PropTypes.string,
  downloadTitle: PropTypes.string,
  provideFeedbackTitle: PropTypes.string,
  provideFeedbackSubtitle: PropTypes.string,
  downloadDataUrl: PropTypes.string,
  feedbackSubmitFailureMessage: PropTypes.string,
  submitFeedback: PropTypes.func,
  modalClose: PropTypes.func,
  navigateToDownloadUrl: PropTypes.func
};
export { DownloadModal as default };